
import { Options, Vue } from "vue-class-component";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import formatDateWithoutTime from "@/app/infrastructures/misc/common-library/FormatDateWithoutTime";
import { formatDate } from "@/app/infrastructures/misc/Utils";
import EmptyState from "@/app/ui/components/empty-list/index.vue";
import OverlayPanel from "primevue/overlaypanel";
import { FlagsPermissionClient } from "@/feature-flags/flags-permission-client";
import { translateStatusClient } from "@/app/ui/views/sales/clients/client-management/utils-client-management";

@Options({
  components: {
    EmptyState,
    OverlayPanel
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    ClientRegistrationController.setSnackbarSuccess("");
    ClientRegistrationController.setSnackbarFailed("");
    next();
  },
  computed: {
    getCurrentRoute() {
      return this.$t("clientManagement.tabs.clientRegistration").toString();
    },
    isDetailAble() {
      return FlagsPermissionClient.permission_client_registration_detail_view.isEnabled();
    },
    isCreateAble() {
      return FlagsPermissionClient.permission_client_registration_add.isEnabled();
    }
  }
})
class ClientRegistrationV2 extends Vue {
  mounted() {
    this.refs = this.$refs;
    ClientRegistrationController.initClient();
  }

  onRequest() {
    ClientRegistrationController.fetchClientList();
  }

  get firstRequest() {
    return ClientRegistrationController.firstRequest;
  }

  get client() {
    return ClientRegistrationController.clientRegistrationData.data;
  }

  //Filter Search
  onSearch(value: string) {
    ClientRegistrationController.searchAction(value);
  }
  get searchValue() {
    return ClientRegistrationController.search;
  }
  clearSearch() {
    ClientRegistrationController.clear();
  }

  get statusData() {
    return [
      { name: this.$t("clientManagement.registrationList.allStatuses").toString(), value: "" },
      { name: this.$t("clientManagement.infoPriceClient.rejected").toString(), value: "rejected" },
      { name: this.$t("clientManagement.infoPriceClient.waiting").toString(), value: "waiting" }
    ];
  }
  statusSelect = false;
  statusName = "";
  onOpenStatusSelect() {
    this.statusSelect = true;
  }
  onCloseStatusSelect() {
    this.statusSelect = false;
  }
  onSelectStatus(name: string, value: string) {
    ClientRegistrationController.selectStatusAction({
      name: name,
      value: value
    });
    this.statusName = name;
    this.onCloseStatusSelect();
  }

  get typeData() {
    return [
      { name: this.$t("clientManagement.managementList.allClientTypes").toString(), value: "" },
      { name: this.$t("clientManagement.managementList.parentClient").toString(), value: "parent" },
      { name: this.$t("clientManagement.managementList.branchClient").toString(), value: "branch" }
    ];
  }
  typeSelect = false;
  typeName = "";
  onOpenTypeSelect() {
    this.typeSelect = true;
  }
  onCloseTypeSelect() {
    this.typeSelect = false;
  }
  onSelectType(name: string, value: string) {
    ClientRegistrationController.selectTypeAction({
      name: name,
      value: value
    });
    this.typeName = name;
    this.onCloseTypeSelect();
  }

  // Table
  get columns() {
    return [
      {
        name: this.$t("clientManagement.registrationList.columns.clientId").toString(),
        styleHead: "w-1/12 text-left whitespace-no-wrap",
        styleBody: "text-red-lp-200 text-center",
        render: (item: any) => {
          return `<span class='text-left text-red-lp-200 flex justify-center'>${item.id}</span>`;
        }
      },
      {
        name: this.$t("clientManagement.registrationList.columns.clientName").toString(),
        styleHead: "w-3/12 text-left whitespace-no-wrap",
        styleBody: "",
        render: (item: any) => {
          return `<span class="overflow-ellipsis text-black-lp-300">${item.clientName}</span>`;
        }
      },
      {
        name: this.$t("clientManagement.registrationList.columns.alias").toString(),
        styleHead: "w-2/12 text-left whitespace-no-wrap",
        styleBody: "",
        render: (item: any) => {
          return `<div class="overflow-ellipsis text-black-lp-300 truncate">${item.clientAlias ||
            "-"}</div>`;
        }
      },
      {
        name: this.$t("clientManagement.registrationList.columns.clientCode").toString(),
        styleHead: "w-2/20 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<span class="overflow-ellipsis text-black-lp-300">${item.clientCode}</span>`;
        }
      },
      {
        name: this.$t("clientManagement.registrationList.columns.clientType").toString(),
        styleHead: "w-2/12 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<span class="overflow-ellipsis text-black-lp-300">${
            item.clientType.toLowerCase() === "client induk"
              ? this.$t("clientManagement.managementList.parentClient").toString()
              : this.$t("clientManagement.managementList.branchClient").toString()
          }</span>`;
        }
      },
      {
        name: this.$t("clientManagement.registrationList.columns.pricePeriodStart").toString(),
        styleHead: "w-3/12 text-left whitespace-no-wrap",
        sortBy: "start_date",
        render: (item: any) => {
          if (!item.clientStartDate) {
            return "<div class='flex text-gray-lp-300'>-</div>";
          }
          return `<div class='flex text-black-lp-300'>
            ${formatDate(item.clientStartDate, "DD MMMM YYYY", false, false)}<br />
            ${formatDate(item.clientStartDate, "HH:mm")}
          </div>`;
        }
      },
      {
        name: this.$t("clientManagement.registrationList.columns.pricePeriodEnd").toString(),
        styleHead: "w-3/12 text-left whitespace-no-wrap",
        sortBy: "end_date",
        render: (item: any) => {
          if (!item.clientEndDate) {
            return "<div class='flex text-gray-lp-300'>-</div>";
          }
          return `<div class='flex text-black-lp-300'>
            ${formatDate( item.clientEndDate, "DD MMMM YYYY", false, false)} <br />
            ${formatDate( item.clientEndDate, "HH:mm")}
          </div>`;
        }
      },
      {
        name: this.$t("clientManagement.registrationList.columns.contractStatus").toString(),
        styleHead: "w-2/12 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `
            <div class="flex">
            <div
              class="rounded-full px-2 py-0 text-center ${this.extractColor(item)}"
            ><span class="capitalize">${
              item.clientStatus.toLowerCase() === "waiting"
                ? this.$t("clientManagement.infoPriceClient.waiting").toString()
                : this.$t("clientManagement.infoPriceClient.rejected").toString()
            }</span></div></div>`;
        }
      },
      {
        name: this.$t("clientManagement.registrationList.columns.priceStatus").toString(),
        styleHead: "w-2/12 text-left whitespace-no-wrap",
        render: (item: any) => {
          if (!item.rateVersionStatus) {
            return "<div class='flex text-black-lp-300'>-</div>";
          }

          const translatedStatus = translateStatusClient(
            item.rateVersionStatus.toLowerCase()
          );

          return `
              <div class="flex">
                <div class="rounded-full px-2 py-0 text-center ${translatedStatus.color} ${translatedStatus.textColor}">
                  <span class="capitalize">${translatedStatus.label}</span>
                </div>
              </div>`;
        }
      }
    ];
  }

  get orderBy() {
    return ClientRegistrationController.orderBy;
  }

  get sortDirection() {
    return ClientRegistrationController.sortDirection;
  }

  onSort(sort: { sortBy: string; sortDirection: "ASC" | "DESC" | "" }) {
    ClientRegistrationController.sortAction({
      orderBy: sort.sortBy,
      sortDirection: sort.sortDirection
    });
  }

  onClickRow(item: any) {
    this.$router.push(`/client/client-registration/${item.id}`);
  }
  goAdd(route: string) {
    this.$router.push(`/client/client-registration/${route}`);
  }

  // Pagination Table
  get pagination() {
    return ClientRegistrationController.clientRegistrationData.pagination;
  }

  //Loading
  get isLoading() {
    return ClientRegistrationController.isLoading;
  }

  //Error
  get isError() {
    return ClientRegistrationController.isError;
  }

  //Error Cause
  get errorCause() {
    return ClientRegistrationController.isErrorCause;
  }

  refs: any = {};
  togglePanel(event: any) {
    const refs: any = this.$refs;
    refs["op"].toggle(event);
  }
  get panelVisible() {
    return this.refs.op?.visible;
  }

  extractColor(item: any) {
    const color: any = {
      "approved": "bg-green-lp-300 text-green-lp-200",
      "waiting": "bg-yellow-lp-200 text-yellow-lp-100"
    }

    return color[item.clientStatus.toLowerCase()] ?? "bg-red-300 text-red-lp-200"
  }
}
export default ClientRegistrationV2;
